/*
  ParseHtmlTags

  Very simple HTML tag parser.

  returns [{
    '>' : 'script',
    'type': 'text/javascript',
    'src': 'https://...',
  }]
*/
const attrPattern = /(\w+)\s*(:?=\s*((?:(['"])(.*?)\4)|(?:[^\s>]+)))?/

module.exports = getTags
getTags.TAG = '>'
Object.assign(module.exports, {
  getTags,
  parseAttrs,
  stripComments
})

function getTags(source, ...tags) {
  const pattern = new RegExp(`<(?:${tags.join('|')})(?:\\s+(.*?))?>`, 'igm')

  return (stripComments(source).match(pattern) || []).map(tags => parseAttrs(tags))
}

function parseAttrs(htmlTagText, tagKey = getTags.TAG) {
  const attrs = {}

  const matchPattern = new RegExp(attrPattern, 'gim')
  let match = matchPattern.exec(htmlTagText)
  if (!match) {
    return
  }
  attrs[tagKey] = match[1].toLowerCase()

  while ((match = matchPattern.exec(htmlTagText))) {
    const key = match[1].toLowerCase()
    attrs[key] =
      (match[5] !== null && match[5]) || (match[3] !== null && match[3]) || true
  }
  return attrs
}

function stripComments(html) {
  return html.replace(/<!--(?:[\s]|.)*?-->/gim, '')
}
